import React from 'react';
import ReactDOM from 'react-dom';
import App from './search-page/App';

const searchPageContainer = document.getElementById('search-page-app');

if (searchPageContainer) {
  /* eslint react/jsx-filename-extension: 0 */
  ReactDOM.render(<App />, searchPageContainer);
}
